import { jsx as _jsx } from "react/jsx-runtime";
export default function LegendLabel(_ref) {
  let {
    flex = '1',
    label,
    margin = '5px 0',
    align = 'left',
    children,
    ...restProps
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: "visx-legend-label",
    style: {
      justifyContent: align,
      display: 'flex',
      flex,
      margin
    },
    ...restProps,
    children: children || label
  });
}